export const toggleExpansion = (index, expandedItems, setExpandedItems) => {
    const newExpandedItems = new Set(expandedItems);

    // add/remove index based on its curr presence in the Set
    if (newExpandedItems.has(index)) {
        newExpandedItems.delete(index); // collapse if expanded
    } else {
        newExpandedItems.add(index); // expand if collapsed
    }
 

    setExpandedItems(newExpandedItems);
};